import React from 'react';

import RatingBadge from '../../components/RatingBadge';
import type { RatingBadgeProps } from '../../components/RatingBadge/RatingBadge';

const RatingBadgeContainer = ({ value, ...props }: RatingBadgeProps) =>
  value && value > 0 ? <RatingBadge value={value} {...props} /> : null;

export default RatingBadgeContainer;
